import React from 'react'
import { connect } from 'react-redux'
import { Layout,Avatar, Menu, Breadcrumb,Button,Row, Col, Divider,Card,Dropdown,Switch,
    message, Tooltip,InputNumber,Table,Popover,Modal,Image,Form,Select,Spin} from 'antd';
import { Drawer, List,Alert,Affix,notification } from 'antd';
import axios from 'axios';
import * as serverconfig from '../../serverconn';
import * as actions from '../../../store/actions/auth';

import {
  DesktopOutlined,
  PieChartOutlined,
  FileOutlined,
  TeamOutlined,
  UserOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  LaptopOutlined,
  NotificationOutlined,
  SettingOutlined,
  AuditOutlined,
  IdcardOutlined,
  BankFilled,
  RightCircleFilled,
  LeftCircleFilled,
  LogoutOutlined,
  BellOutlined,
  SearchOutlined,
  FilterOutlined,
  EyeOutlined,
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  ReloadOutlined,
  DownloadOutlined,
  PrinterOutlined,
  CarOutlined,
  InboxOutlined,
  LineChartOutlined,
  DatabaseOutlined,
  ToolOutlined,
  SafetyOutlined,
  GlobalOutlined,
  ContactsOutlined,
  BankOutlined,
  BarcodeOutlined,
  FileTextOutlined,
  DeploymentUnitOutlined,
  BarChartOutlined,
  EnvironmentOutlined,
  UserSwitchOutlined,
  ShoppingOutlined,
  GiftOutlined,
  MedicineBoxOutlined,
  TruckOutlined,
  DashboardOutlined,
  MonitorOutlined,
  ApiOutlined,
  KeyOutlined
} from '@ant-design/icons';
import { Badge, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem } from 'reactstrap';
import UIfx from 'uifx';

import { NavLink } from 'react-router-dom'
import { PageHeader, Descriptions } from 'antd';

const { Header, Content, Sider } = Layout;
const { SubMenu } = Menu;

const DescriptionItem = ({ title, content }) => (
  <div
    className="site-description-item-profile-wrapper"
    style={{
      fontSize: 14,
      lineHeight: '22px',
      marginBottom: 7,
    }}
  >
    <p
      className="site-description-item-profile-p"
      style={{
        marginRight: 8,
        display: 'inline-block',
      }}
    >
      {title}:
    </p>
    {content}
  </div>
);

class HubLayout extends React.Component {
  state = {
    collapsed: false,
    titlecolor: '#fff',
    titlevisibility:"visible",
    userprofile:{},
    companyprofile:{},
    isToggle: null,
    visible: false,
    resetmodalvisible: false,
    updateformvisible: 'none',
    userrights: {},
    notifications: [],
    hub_info: {}
  };

  componentDidMount(){
    this.fetchUserProfile();
    this.fetchCompanyProfile();
    this.fetchNotifications();
  }

  fetchUserProfile = () => {
    if(localStorage.getItem("token")){
      const token = localStorage.getItem("token");
      
      axios.defaults.headers={
        "Content-Type":"application/json",
        Authorization:`Token ${token}`
      }

      axios.get(serverconfig.backendserverurl+`/current_user_profile`)
      .then(res => {
        this.setState({
          userprofile:res.data
        });
        this.fetchUserRights();
        this.fetchHubInfo(res.data.coodinated_hub);
      })
    }
  };

  fetchCompanyProfile = () => {
    if(localStorage.getItem("token")){
      const token = localStorage.getItem("token");
      
      axios.defaults.headers={
        "Content-Type":"application/json",
        Authorization:`Token ${token}`
      }

      axios.get(serverconfig.backendserverurl+`/api/app_profile/${1}`)
      .then(res => {
        this.setState({
          companyprofile:res.data
        })
      })
    }
  };

  fetchUserRights = () => {
    if(localStorage.getItem("token")){
      const token = localStorage.getItem("token");
      
      axios.defaults.headers={
        "Content-Type":"application/json",
        Authorization:`Token ${token}`
      }

      axios.get(serverconfig.backendserverurl+`/api/account_rights/`)
      .then(res => {
        this.setState({
          userrights:res.data
        })
      })
    }
  };

  fetchHubInfo = (hubId) => {
    if(hubId){
      if(localStorage.getItem("token")){
        const token = localStorage.getItem("token");
        
        axios.defaults.headers={
          "Content-Type":"application/json",
          Authorization:`Token ${token}`
        }

        axios.get(serverconfig.backendserverurl+`/api/collectionhub/${hubId}/`)
        .then(res => {
          this.setState({
            hub_info: res.data
          })
        })
      }
    }
  };

  fetchNotifications = () => {
    if(localStorage.getItem("token")){
      const token = localStorage.getItem("token");
      
      axios.defaults.headers={
        "Content-Type":"application/json",
        Authorization:`Token ${token}`
      }

      axios.get(serverconfig.backendserverurl+`/api/admin_notifications/`)
      .then(res => {
        this.setState({
          notifications:res.data
        })
      })
    }
  };

  onCollapse = collapsed => {
    this.setState({ collapsed });
  };

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userid');
    window.location.href = '/';
  };

  // show the profile modal
  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  // update user profile
  showUpdateForm = () => {
    this.state.updateformvisible === "none" ?
    this.setState({
      updateformvisible: "block",
    }) :
    this.setState({
      updateformvisible: "none",
    })    
  }

  // password reset modal
  showpasswordresetModal = () => {
    this.setState({
      resetmodalvisible: true,
    });
  };

  onresetdrawerClose = () => {
    this.setState({
      resetmodalvisible: false,
    });
  };

  handleMenuClick = ({ key }) => {
    console.log('🔍 HubLayout: Menu item clicked:', key);
    switch (key) {
      case 'profile':
        console.log('🔍 HubLayout: Profile clicked');
        this.showDrawer();
        break;
      case 'settings':
        console.log('🔍 HubLayout: Settings clicked');
        this.showpasswordresetModal();
        break;
      case 'logout':
        console.log('🔍 HubLayout: Logout clicked');
        this.logout();
        break;
      default:
        console.log('🔍 HubLayout: Unknown menu item:', key);
        break;
    }
  };

  render() {
    console.log('🔍 HubLayout: Rendering with props:', this.props);
    console.log('🔍 HubLayout: Children:', this.props.children);
    const { collapsed, userprofile, companyprofile, userrights, hub_info } = this.state;
    
    return (
      <React.Fragment>
      <Layout style={{ minHeight: '100vh' }}>
        <Sider 
          collapsible 
          collapsed={collapsed} 
          onCollapse={this.onCollapse}
          style={{
            background: '#fff',
            boxShadow: '2px 0 6px rgba(0,21,41,.35)',
          }}
        >
          {/* Hub Header */}
          <div style={{ 
            padding: collapsed ? '16px 8px' : '16px 24px',
            borderBottom: '1px solid #f0f0f0',
            textAlign: 'center'
          }}>
            <Row justify="center" align="middle">
              <Col span={collapsed ? 24 : 6}>
                <img 
                  height={collapsed ? 32 : 40} 
                  width={collapsed ? 32 : 40} 
                  alt="Logo" 
                  src={companyprofile.company_logo} 
                  style={{border:'1px solid #ddd', borderRadius:'5px'}} 
                />
              </Col>
              {!collapsed && (
                <Col span={18}>
                  <div style={{textAlign:'left', paddingLeft: '12px'}}>
                    <h5 style={{color:'#1890ff', margin:'0', fontSize:'14px', fontWeight:'bold'}}>
                      {hub_info.name || 'Hub Manager'}
                    </h5>
                    <p style={{margin:'2px 0', fontSize:'12px', color:'#666'}}>
                      Hub Management Dashboard
                    </p>
                  </div>
                </Col>
              )}
            </Row>
          </div>

          {/* Hub Manager Menu */}
          <Menu
            mode="inline"
            defaultSelectedKeys={['hub_dashboard']}
            style={{ height: '100%', borderRight: 0 }}
          >
            {/* Dashboard */}
            <Menu.Item key="hub_dashboard">
              <DashboardOutlined />
              <NavLink to='/'><span>Hub Overview</span></NavLink>
            </Menu.Item>

            {/* Operations */}
            <SubMenu
              key="hub_operations"
              title={
                <span>
                  <InboxOutlined />
                  <span>Operations</span>
                </span>
              }
            >
              <Menu.Item key="hub_deliveries">
                <CarOutlined />
                <NavLink to='/hub_deliveries/'><span>Hub Deliveries</span></NavLink>
              </Menu.Item>

              <Menu.Item key="hub_online_agents">
                <SafetyOutlined />
                <NavLink to='/hub_online_agents/'><span>Online Agents</span></NavLink>
              </Menu.Item>
            </SubMenu>

            {/* Reports & Analytics */}
            <SubMenu
              key="hub_reports"
              title={
                <span>
                  <BarChartOutlined />
                  <span>Reports & Analytics</span>
                </span>
              }
            >
              <Menu.Item key="hub_agent_activity_map">
                <GlobalOutlined />
                <NavLink to='/hub_agent_activity_map/'><span>Agent Activity Map</span></NavLink>
              </Menu.Item>

              <Menu.Item key="hub_analytics_graphs">
                <LineChartOutlined />
                <NavLink to='/hub_analytics_graphs/'><span>Analytics Graphs</span></NavLink>
              </Menu.Item>
            </SubMenu>

            {/* Agents & Facilities */}
            <SubMenu
              key="hub_management"
              title={
                <span>
                  <TeamOutlined />
                  <span>Management</span>
                </span>
              }
            >
              <Menu.Item key="hub_deliveryagents">
                <UserOutlined />
                <NavLink to='/hub_deliveryagents/'><span>Hub Agents</span></NavLink>
              </Menu.Item>

              <Menu.Item key="hub_healthcenters">
                <BankOutlined />
                <NavLink to='/hub_healthcenters/'><span>Hub Health Centers</span></NavLink>
              </Menu.Item>
            </SubMenu>
          </Menu>
        </Sider>

        <Layout>
          <Header style={{ 
            background: '#fff', 
            padding: '0 24px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={this.toggle}
              style={{
                fontSize: '16px',
                width: 64,
                height: 64,
              }}
            />
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              {/* Notifications */}
              <Badge count={this.state.notifications.length}>
                <BellOutlined style={{ fontSize: '18px', cursor: 'pointer' }} />
              </Badge>

              {/* User Profile Dropdown */}
              <Dropdown.Button 
                overlay={
                  <Menu onClick={this.handleMenuClick}>
                    <Menu.Item key="logout">
                      <LogoutOutlined />
                      Log out
                    </Menu.Item>
                    <Menu.Item key="profile">
                      <UserOutlined />
                      View Profile
                    </Menu.Item>
                    <Menu.Item key="settings">
                      <KeyOutlined />
                      Change Password
                    </Menu.Item>
                  </Menu>
                }
                placement="bottomRight"
              >
                Hi, {userprofile.username || 'Hub Manager'}
              </Dropdown.Button>
            </div>
          </Header>

          <Content style={{ 
            margin: '24px 16px',
            padding: 24,
            background: '#fff',
            minHeight: 280,
          }}>
            {this.props.children}
          </Content>
        </Layout>
      </Layout>

      {/* Profile Drawer */}
      <Drawer
        title="Account Profile"
        width={520}
        placement="right"
        closable={false}
        onClose={this.onClose}
        visible={this.state.visible}
      >
        <p style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>      
           <Avatar
            size={100}
            icon={<UserOutlined />}
            alt="client logo"
            src={serverconfig.backendserverurl + (userprofile.profile_pic || '')}
            />
        </p>
        <Row>
          <Col span={12}>
            <DescriptionItem title="User Name" content={userprofile.username} />
          </Col>
          <Col span={12}>
            <DescriptionItem title="Email" content={userprofile.email} />
          </Col>
        </Row>         
        <p style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>      
           <Button type="primary" onClick={this.showUpdateForm}>
             {
               this.state.updateformvisible === "none" ?
               "Open Update Form"
               :
               "Close Update Form"
             }
           </Button>
        </p>
        
        <div style={{display: this.state.updateformvisible}}>
         <p>Profile update form coming soon!</p>
        </div>
      </Drawer>

      {/* Password Reset Drawer */}
      <Drawer
        title="Password Change Form"
        width={520}
        placement="right"
        closable={false}
        onClose={this.onresetdrawerClose}
        visible={this.state.resetmodalvisible}
      >
        <p>Password reset form coming soon!</p>
      </Drawer>
    </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.token,
    userid: state.userid
  }
}

const mapDispatchToProps = dispatch => {
  return {
    logout: () => dispatch(actions.logout())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HubLayout);
